import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconIconShape12 from './IconIconShape12';
import IconIconShape16 from './IconIconShape16';
import IconIconShape20 from './IconIconShape20';
import IconIconShape24 from './IconIconShape24';
import IconIconShape32 from './IconIconShape32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconIconShape = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconIconShape12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconIconShape16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconIconShape20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconIconShape24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconIconShape32 {...props} />}
        </span>
    );
};
IconIconShape.displayName = 'FondueIconIconShape';

export default memo(IconIconShape);
